import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/App';
import { disableReactDevTools } from '@fvilers/disable-react-devtools';

//disable react dev-tools
if (process.env.NODE_ENV === 'production') {
    disableReactDevTools();
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
